import styles from '../../styles.module.scss'
import Template from '../templateComponent/Template'

const SoapTemplates = () => (
    <div className={styles.templatesRoot}>
      <span className={styles.titleh2}>Work in progress...</span>
      {/*<Template title="Is food available?">
        <span>Its getting ready</span>
      </Template>
      <Template title="Is bike available?">
        <span>YES</span>
      </Template>*/}
    </div>
  )

export default SoapTemplates
